module.exports = __webpack_public_path__ + "1.5.0-unryo/img/step1.3d36be9d.png";